/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Bell_LabelInputs */

const en_notifications_bell_label = /** @type {(inputs: Notifications_Bell_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open notifications`)
};

const pt_br2_notifications_bell_label = /** @type {(inputs: Notifications_Bell_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir notificações`)
};

/**
* | output |
* | --- |
* | "Open notifications" |
*
* @param {Notifications_Bell_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_bell_label = /** @type {((inputs?: Notifications_Bell_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Bell_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_bell_label(inputs)
	return pt_br2_notifications_bell_label(inputs)
});